import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Button, ReduxControls } from "rhombus-react";
import { reduxForm, Field, getFormValues, clearFields } from "redux-form";

import { LABEL_MANAGEMENT } from "widgets/forms/list";
import ProgressContainer from "widgets/ProgressContainer";

import { addCreativeLabels, addVersionLabels } from "reducers/Labels";
import { noop } from "utils/common";
import { maxOptions } from "widgets/forms/validators/validators";

const ALL_CATEGORIES_OPTION = {
	label: "All",
	value: "all",
};

const MAX_LABEL_OPTIONS = 50;
const maxLabels = maxOptions(MAX_LABEL_OPTIONS, "labels");

function mapCategoryToOption(category){
	return {
		label: category.name,
		value: category.id,
	};
}

function mapLabelToOption(label){
	return {
		label: label.prettyName,
		value: label.id,
	};
}

function LabelManagementFormComponent(props){
	const {
		invalid,
		handleSubmit,
	} = props;
	const dispatch = useDispatch();
	const { category, labels = []} = useSelector(getFormValues(LABEL_MANAGEMENT)) || {};
	const advertiserTaxonomy = useSelector(state => state.labels.advertiserTaxonomy);
	const advertiserCategoryOptions = advertiserTaxonomy?.categories?.map(mapCategoryToOption) || [];
	const categoryOptions = [
		ALL_CATEGORIES_OPTION,
		...advertiserCategoryOptions,
	];

	const categoryValue = category?.value;

	const labelOptionsRaw = (categoryValue === "all") ? advertiserTaxonomy?.allLabels : advertiserTaxonomy?.labelsByCategoryId?.[`${categoryValue}`];
	const labelOptions = labelOptionsRaw?.map(mapLabelToOption) || [];

	const [isSaving, setIsSaving] = useState(false);

	function onSubmit(){
		setIsSaving(true);
		handleSubmit().then(() => {
			dispatch(clearFields(LABEL_MANAGEMENT, false, false, "labels"));
			setIsSaving(false);
		});
	}

	return (
		<ProgressContainer className={LABEL_MANAGEMENT} isLoading={isSaving || !advertiserTaxonomy.isLoaded}>
			<div className="label-management-content">
				<Field
					name="category"
					label="Category"
					component={ReduxControls.Select}
					options={categoryOptions}
					isClearable={false}
					onMenuScrollToBottom={noop}
				/>
				<Field
					name="labels"
					label="Labels"
					placeholder="Search and Select..."
					component={ReduxControls.Select}
					allowCreate
					isMulti
					isClearable={false}
					options={labelOptions}
					onMenuScrollToBottom={noop}
					validate={maxLabels}
				/>

				<Button
					onClick={onSubmit}
					disabled={invalid || isSaving || !labels?.length}
				>
					Add Labels
				</Button>
			</div>
		</ProgressContainer>
	);
}

const LabelManagementForm = reduxForm({
	form: "label-management",
	initialValues: {
		category: ALL_CATEGORIES_OPTION,
	},
	onSubmit(values, dispatch, props){
		const { libraryId, creativeId, versionId } = props;
		const { labels = []} = values;

		if(!labels.length){ return; }
		const labelIds = labels?.map(label => label.value);

		if(versionId){
			return dispatch(addVersionLabels(creativeId, versionId, labelIds));
		}
		return dispatch(addCreativeLabels(libraryId, creativeId, labelIds));
	},
	destroyOnUnmount: false,
})(LabelManagementFormComponent);

export default LabelManagementForm;
